var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPinterestinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.087,
    height: 28.086,
    className: "pinterest_inline_svg__css-12hibeq"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.421.005A14.043 14.043 0 1028.086 14.04 13.855 13.855 0 0014.421.005m1.254 18.284a2.666 2.666 0 01-2.286-1.22s-.54 2.256-.66 2.7a8.346 8.346 0 01-.91 2.058c-.5.66-1.067.166-1.134-.436a8.839 8.839 0 01.165-2.2c.179-.79 1.2-5.345 1.2-5.345a3.972 3.972 0 01-.3-1.554c0-1.456.81-2.538 1.809-2.538.848 0 1.261.67 1.261 1.475a22.281 22.281 0 01-.823 3.483 1.5 1.5 0 001.473 1.89c1.771 0 2.965-2.395 2.965-5.226a3.575 3.575 0 00-3.894-3.755 4.538 4.538 0 00-4.6 4.7 2.917 2.917 0 00.615 1.923.486.486 0 01.134.551c-.045.181-.147.614-.194.784a.313.313 0 01-.462.241c-1.311-.554-1.918-2.056-1.918-3.746a6.319 6.319 0 016.688-6.128 5.707 5.707 0 015.921 5.62c.005 3.852-2.04 6.728-5.047 6.728",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

export default SvgPinterestinline;